"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ForkJoinObservable_1 = require("./ForkJoinObservable");
exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
//# sourceMappingURL=forkJoin.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/forkJoin.js
// module id = 486
// module chunks = 4